export default __webpack_public_path__ + "coupon-ticket.928a66f5e50858e0f58d4e9542b59587.svg";